module.exports = __webpack_public_path__ + "static/media/ic_canvas_mark.3196304b.svg";